.col--align-text-center {
  text-align: center;
}

.col--align-text-end {
  text-align: end;
}

.col--align-items {
  display: flex;
}

.col--align-items-center {
  align-items: center;
}

.col--align-items-flex-end {
  align-items: flex-end;
}

.col--align-items-flex-start {
  align-items: flex-start;
}

.col--justify-content {
  display: flex;
}

.col--justify-content-center {
  justify-content: center;
}

.col--justify-content-end {
  justify-content: flex-end;
}
